import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getTranslation } from '@/store/getters'
import { updateActualElement, setActiveElement } from '@/store/actions'


/** Components */
import VideoUrl from '@/components/editors/VideoUrl'
import Border from '@/components/editors/Border'
import BoxShadow from '@/components/editors/BoxShadow'
import BorderRadius from '@/components/editors/BorderRadius'

class VideoContent extends Component {
  state = {
    type: 'video'
  }

  save = element => {
    const { id, id_page: pageID } = element
    const { updateActualElement, user: { accessToken } } = this.props

    updateActualElement({
      id,
      pageID,
      element,
      accessToken
    })
  }

  handleStyles = style => {
    const { element } = this.props

    element.content.styles = {
      ...element.content.styles,
      ...style
    }
    this.save(element)
  }

  handleSrc = src => {
    const { element } = this.props

    element.content.src = src
    this.save(element)
  }

  handleOptions = options => {
    const { element } = this.props

    element.content.options = options
    this.save(element)
  }

  handleBorder = ({ type, size, color }) => this.handleStyles({
    borderStyle: type,
    borderWidth: `${size}px`,
    borderColor: color
  })

  handleShadow = shadow => this.handleStyles({
    boxShadow: `${shadow.x}px ${shadow.y}px ${shadow.blur}px ${shadow.color}`
  })

  render() {
    const { translation, element } = this.props

    const {
      borderWidth,
      borderStyle,
      borderColor,
      boxShadow,
      borderTopLeftRadius,
      borderTopRightRadius,
      borderBottomLeftRadius,
      borderBottomRightRadius,
    } = element.content.styles

    const { src, options } = element.content

    return (
      <div className={'ba-pd-r-1'}>
        <hr className={'ba-hr'} />

        <p className='ba-font'>Video</p>

        <VideoUrl
          src={src}
          options={options}
          onChangeSrc={this.handleSrc}
          onChangeOptions={this.handleOptions}
        />

        <hr className={'ba-hr'} />

        <span className={'ba-font'}>{translation('general-border')}</span>
        <Border
          type={borderStyle}
          size={borderWidth}
          color={borderColor}
          onChange={this.handleBorder}
        />

        <hr className={'ba-hr'} />

        <span className={'ba-font'}>{translation('general-shadow')}</span>
        <BoxShadow
          shadow={boxShadow}
          onChange={this.handleShadow}
        />

        <hr className={'ba-hr'} />

        <span className={'ba-font'}>{translation('general-border-radius')}</span>
        <BorderRadius
          topLeft={borderTopLeftRadius}
          topRight={borderTopRightRadius}
          bottomLeft={borderBottomLeftRadius}
          bottomRight={borderBottomRightRadius}
          onChange={this.handleStyles}
        />

      </div>
    )
  }
}

const mapStateProps = state => {
  const translation = getTranslation(state)
  return { translation }
}

export default connect(mapStateProps,
  {
    updateActualElement,
    setActiveElement
  }
)(VideoContent)


// WEBPACK FOOTER //
// ./src/pages/Editor/components/ContentEditor/editors/VideoContent/index.js